const MenuProps = {
  autoFocus: false,
  style: {
    maxHeight: '275px',
  },
};

export { MenuProps };
